import {
  AlertTriangleIcon,
  CheckCircleIcon,
  InfoIcon,
  Loader2Icon,
  XCircleIcon,
} from 'lucide-react';
// import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  // const { theme = 'system' } = useTheme();

  return (
    <Sonner
      // theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg !gap-3',
          description: 'group-[.toast]:!text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:!text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]!text-muted-foreground',
        },
      }}
      icons={{
        success: <CheckCircleIcon className="size-5 text-green-500" />,
        info: <InfoIcon className="size-5 text-blue-500" />,
        warning: <AlertTriangleIcon className="size-5 text-amber-500" />,
        error: <XCircleIcon className="size-5 text-red-500" />,
        loading: <Loader2Icon className="size-5 animate-spin text-gray-500" />,
      }}
      {...props}
    />
  );
};

export { Toaster };
